import { createServerFn } from '@tanstack/react-start'
import { getFromS3, listFromS3 } from '../../lib/s3'
import type { Sticker, StickerListItem } from './stickerSchemas'

/**
 * Get list of all stickers
 */
export const getStickers = createServerFn({ method: 'GET' }).handler(
  async (): Promise<StickerListItem[]> => {
    try {
      const keys = await listFromS3('stickers/')
      const stickers: StickerListItem[] = []
      for (const key of keys) {
        if (key && key.endsWith('.json')) {
          const sticker: Sticker = await getFromS3(key)
          stickers.push({
            id: sticker.id,
            name: sticker.name,
          })
        }
      }
      return stickers.sort((a, b) => a.name.localeCompare(b.name))
    } catch (error) {
      return []
    }
  },
)
